module.exports = __webpack_public_path__ + "img/outside_pet_clinic_splash.8984ba39.jpg";